import { useParams, Prompt, Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { statusToString } from "./Invoices";
import useFetch from '../../../hooks/fetchMSSQL-hook'
import NoResults from "../../../components/NoResults/NoResults";
import { NavigationContext } from "../../../context/navigation-context";
import link from '../../../assets/images/back_to_list_icon.svg'
import { getInvoiceTotal } from './Invoices';
import { NotificationManager } from 'react-notifications';
const Invoice = () => {
    const params = useParams(),
        { setHeaderData } = useContext(NavigationContext)

    const { fetchMssqlApi } = useFetch()

    const [customerAbbr, setCustomerAbbr] = useState('');
    const [invoice, setInvoice] = useState([]);
    const [invoiceItem, setInvoiceItem] = useState([]);
    const [invoiceType, setInvoiceType] = useState([]);
    const [id, setId] = useState(params.id);
    const [generating, setGenerating] = useState(false)
    const [sending, setSending] = useState(false)
    const [isApproved, setIsApproved] = useState(false)
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [customerEmail, setCustomerEmail] = useState('');
    const [pdfAlreadyExists, setPdfAlreadyExists] = useState(false);
    const [prevInvoiceItems, setPrevInvoiceItems] = useState([]);

    const getInvoice = async () => {
        fetchMssqlApi(`invoice/${id}`, { method: 'GET' }, res => {
            setCustomerAbbr(res[0][0][0].CustomerAbbr);
            setInvoice(res[0][0][0]);
            setHeaderData({ text: "Faktura " + (res[0][0][0].InternalNumber || '') })
            if (res[0][0][0].Status === 'B') {
                setIsApproved(true);
            } else {
                setIsApproved(false);
            }
            const items = res[0][1].map(item => ({ ...item, isDeleted: false }));
            setInvoiceItem(items);

            const currentInvoice = res[0][0][0];
            if (currentInvoice.IssuedFor) {
                const [year, month] = currentInvoice.IssuedFor.split('-');
                let prevMonth = parseInt(month, 10) - 1;
                let prevYear = parseInt(year, 10);
                if (prevMonth === 0) {
                    prevMonth = 12;
                    prevYear -= 1;
                }
                const prevIssuedFor = `${prevYear}-${prevMonth.toString().padStart(2, '0')}`;
                
                fetchMssqlApi('invoices', { method: 'GET', hideNotification: true }, invoicesRes => {
                    const allInvoices = invoicesRes[0][0];
                    const allItems = invoicesRes[0][1];
                    const prevInvoice = allInvoices.find(inv => inv.CustomerAbbr === currentInvoice.CustomerAbbr && inv.IssuedFor === prevIssuedFor);
                    if (prevInvoice) {
                        const prevItems = allItems.filter(item => item.InvoiceId === prevInvoice.InvoiceId);
                        setPrevInvoiceItems(prevItems);
                    } else {
                        setPrevInvoiceItems([]);
                    }
                });
            }
        })
    }

    const getInvoiceTypes = async () => {
        fetchMssqlApi(`invoice-type/`, { method: 'GET' }, res => {
            setInvoiceType(res);
        })
    }

    const getCustomerEmail = async () => {
        fetchMssqlApi(`invoice-email/${customerAbbr}`, { method: 'GET' }, res => {
            setCustomerEmail(res[0].InvoiceEmail);
        })
    }

    const handleSaveCustomerEmail = () => {
        fetchMssqlApi(`invoice-email/${customerAbbr}`, {
            method: 'PUT',
            data: {
                CustomerAbbr: customerAbbr,
                email: customerEmail
            }
        }, res => {
            getCustomerEmail();
        })
    }

    const checkInvoicePdfExists = async () => {
        let id = invoice.InternalNumber.split("/")[2];
        fetchMssqlApi(`invoice/invoice-exists/${id}/${customerAbbr}`, { method: 'GET' }, res => {
            if (res.exists) {
                setPdfAlreadyExists(true);
            }
        })
    }

    useEffect(() => {
        if (customerAbbr) {
            getCustomerEmail();
        }
    }, [customerAbbr]);

    useEffect(() => {
        if(invoice.InternalNumber)
            checkInvoicePdfExists();
    }, [invoice]);

    useEffect(() => {
        setId(params.id);
        getInvoice()
        getInvoiceTypes();
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (unsavedChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [unsavedChanges]);

    const generateInvoicePdf = async () => {
        setGenerating(true);
        fetchMssqlApi(
            'invoice/generate-pdf',
            {
                method: 'POST',
                data: {
                    invoiceId: id,
                    customerAbbr: customerAbbr
                },
                hideNotification: false 
            },
            (res) => {
                setGenerating(false);
                checkInvoicePdfExists();
            },
            (err) => {
                console.error(err);
                NotificationManager.error("Nie udalo sie wygenerowac pdf.");
                setGenerating(false);
            }
        );
    };

    const downloadInvoicePdf = async () => {
        fetchMssqlApi(
            `invoice/download-pdf/${customerAbbr}/${id}`,
            {
                method: 'GET',
                responseType: 'blob',
                hideNotification: true
            },
            (res) => {
                const blob = new Blob([res], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                let name = `FV_`;
                name += invoice.IssuedFor.replace("-", "_") + "_";
                name += invoice.InternalNumber.split("/")[2] + "_" + invoice.CustomerAbbr + ".pdf";

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();

                link.remove();
                window.URL.revokeObjectURL(url);
            },
            (err) => {
                console.error(err);
                window.alert("Błąd podczas pobierania pliku");
            }
        );
    };

    const sendingInvoice = async () => {
        try {
            setSending(true);

            await fetchMssqlApi(
                'invoice/send-email',
                {
                    method: 'POST',
                    isErrorAcceptable: true,
                    data: {
                        invoiceId: invoice.InternalNumber.split("/")[2],
                        customerAbbr: customerAbbr
                    },
                    hideNotification: true
                },
                (res) => {
                    if (res.status === 200) {
                        NotificationManager.success(res.success)
                    } else {
                        NotificationManager.error(res.error)
                    }
                }
            );
        } catch (err) {
            console.error("Critical email error:", err);
        } finally {
            setSending(false);
        }
    }

    const acceptInvoice = async () => {
        setIsApproved(true);
        fetchMssqlApi(`invoice/${id}/status`, {
            method: 'PUT',
            data: {
                invoiceId: id,
                newStatus: 'B'
            },
        }, res => {
            getInvoice();
        })
    }

    const cancelApproval = async () => {
        if (!window.confirm("Czy na pewno chcesz cofnąć zatwierdzenie? Faktura wróci do edycji.")) return;

        setIsApproved(false);
        fetchMssqlApi(`invoice/${id}/status`, {
            method: 'PUT',
            data: {
                invoiceId: id,
                newStatus: 'A'
            },
        }, res => {
            getInvoice();
        })
    }


    const addPosition = () => {
        if (isApproved) return;
        setInvoiceItem([...invoiceItem, {
            Quantity: 0,
            PriceNetto: 0,
            ProductNo: 0,
            ProductName: '-',
            VATRate: 23,
            isDeleted: false,
            IsPLN: 0
        }]);
        setUnsavedChanges(true);
    }

    const removePosition = (index) => {
        setInvoiceItem(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, isDeleted: true } : item
            )
        );
        setUnsavedChanges(true);
    }

    const handleItemChange = (index, field, value) => {
        if (isApproved) return;
        const newItems = [...invoiceItem];
        newItems[index] = {
            ...newItems[index],
            [field]: value
        };
        setInvoiceItem(newItems);
        setUnsavedChanges(true);
    }

    const handleSaveItems = async () => {
        const itemsToSend = invoiceItem.filter(item => !item.isDeleted);

        fetchMssqlApi('invoice/update-items', {
            'method': 'PUT',
            data: {
                invoiceId: id,
                items: JSON.stringify(itemsToSend)
            }
        }, (res) => {
            setUnsavedChanges(false);
            setInvoiceItem(itemsToSend);
        })
    }

    const totalQuantity = React.useMemo(() => {
        if (!invoiceItem) return 0;

        return invoiceItem
            .filter(detail => !detail.isDeleted)
            .reduce((sum, detail) => sum + Number(detail.Quantity || 0), 0);
    }, [invoiceItem]);

    let visualIndex = 0;

    return (
        invoice && invoiceType ? (
            <>
                <Link to='/invoices' style={{ textDecoration: 'none', width: 40, margin: '20px' }}>
                    <img style={{ width: 40, backgroundColor: 'black' }} id='back' src={link}></img>
                </Link>
                <div className="row">
                    <Prompt
                        when={unsavedChanges}
                        message="Masz niezapisane zmiany. Czy na pewno chcesz opuścić tę stronę?"
                    />

                    <div className="col-12 col-md-4 mb-3">
                        <div className='card'>
                            <div className='card-header'>
                                Szczegóły faktury ({invoice.InternalNumber})
                            </div>
                            <div className='card-body'>
                                <div className='mb-3'>
                                    <div className='h-6'>Numer faktury</div>
                                    <input className="form-control mt-2 mb-2" type='text' value={invoice.InternalNumber || ''} disabled={true} />

                                    <label className='h-6'>Klient</label>
                                    <input className="form-control mb-2" type='text' value={invoice.CustomerAbbr || ''} disabled={true} />

                                    <label className='h-6'>Data utworzenia</label>
                                    <input className="form-control mb-2" type='text' value={(String(invoice.CreateDateTime || '').replace("T", " ").slice(0, 19)) || ''} disabled={true} />

                                    <label className='h-6'>Status</label>
                                    <input className="form-control mb-2" type='text' value={statusToString(invoice.Status) || ''} disabled={true} />
                                    <label className='h-6'>Kurs EUR dla danej faktury</label>
                                    <input className="form-control mb-2" type='text' value={invoice.PriceEUR + "zł"} disabled={true} />

                                    <div className="row">
                                        <div className="col-sm">
                                            <label className='h-6'>Suma ilości</label>
                                            <input className="form-control mb-2" type='text' value={totalQuantity} disabled={true} />
                                        </div>
                                        <div className="col-sm">
                                            <label className='h-6'>Suma netto</label>
                                            <input className="form-control mb-2" type='text' value={getInvoiceTotal(invoice, invoiceItem) + ' zł'} disabled={true} />
                                        </div>
                                        <div className="col-sm">
                                            <label className='h-6'>Suma brutto</label>
                                            <input className="form-control mb-2" type='text' value={(getInvoiceTotal(invoice, invoiceItem) * 1.23).toFixed(2) + ' zł'} disabled={true} />
                                        </div>
                                    </div>

                                    <label className='h-6'>E-Mail klienta</label>
                                    <div className="d-flex align-items-center mb-2">
                                        <input
                                            className="form-control mr-2"
                                            type='email'
                                            value={customerEmail}
                                            onChange={(e) => setCustomerEmail(e.target.value)}
                                            disabled={false}
                                        />
                                        <button
                                            className="btn btn-outline-info text-nowrap"
                                            onClick={handleSaveCustomerEmail}
                                        >
                                            Zapisz
                                        </button>
                                    </div>

                                    <div className="d-flex align-items-center mb-2 flex-wrap">

                                        {!isApproved ? (
                                            <button
                                                className="btn btn-outline-success mr-2 mt-4"
                                                onClick={acceptInvoice}
                                            >
                                                Zatwierdź fakturę
                                                `      </button>
                                        ) : (
                                            <button
                                                className="btn btn-dark mr-2 mt-4"
                                                onClick={cancelApproval}
                                            >
                                                <i className="fas fa-undo mr-1"></i>
                                                Cofnij zatwierdzenie
                                            </button>
                                        )}

                                    </div>
                                    <div className="d-flex align-items-end mb-2 flex-wrap">
                                        <div className="btn-group mt-4 mr-2" role="group">
                                            {pdfAlreadyExists && (
                                                <button
                                                    disabled={generating || !isApproved}
                                                    download="faktura.pdf"
                                                    className="btn btn-outline-primary "
                                                    onClick={downloadInvoicePdf}
                                                >
                                                    Pobierz pdf
                                                </button>
                                            )}

                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={generateInvoicePdf}
                                                disabled={generating || !isApproved}
                                                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                            >
                                                {generating ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                        {pdfAlreadyExists ? "" : "Generowanie..."}
                                                    </>
                                                ) : (
                                                    pdfAlreadyExists ? <i className="fas fa-redo-alt mr-2" /> : 'Generuj PDF'
                                                )}
                                            </button>
                                        </div>
                                        <button className="btn btn-outline-primary mr-2 mt-4" onClick={sendingInvoice} disabled={sending || !isApproved || !pdfAlreadyExists}>
                                            {sending ? 'Wysyłanie...' : `Wyslij fakturę`}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-8">
                        <div className='card'>
                            <div className='card-header d-flex justify-content-between'>
                                <h5>Pozycje</h5>
                                <button
                                    onClick={addPosition}
                                    disabled={isApproved}
                                    className="btn text-nowrap btn-outline-secondary"
                                >
                                    <i className="fas fa-plus" />
                                </button>
                            </div>
                            <div className='card-body pt-0'>
                                <table className='table table-striped'>
                                    <thead>
                                        <tr>
                                            <td>Numer</td>
                                            <td>Ilość</td>
                                            <td>Cena Netto</td>
                                            <td>Czy w PLN?</td>
                                            <td >Produkt</td>
                                            <td >Opis produktu</td>
                                            <td >VAT</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceItem && invoiceItem.length ? invoiceItem.map((inv, idx) => {
                                            const selectedProduct = inv.ProductNo;
                                            const isDeleted = inv.isDeleted;
                                            const prevItem = prevInvoiceItems.find(p => Number(p.ProductNo) === Number(selectedProduct) && Number(selectedProduct) !== 0);

                                            if (!isDeleted) {
                                                visualIndex++;
                                            }

                                            const rowStyle = isDeleted ? {
                                                textDecoration: 'line-through',
                                                opacity: 0.5,
                                                backgroundColor: '#ffe6e6'
                                            } : {};

                                            const differences = [];
                                            if (prevItem && Number(prevItem.Quantity) !== Number(inv.Quantity)) {
                                                differences.push(`Ilość (było: ${prevItem.Quantity})`);
                                            }
                                            if (prevItem && Number(prevItem.PriceNetto) !== Number(inv.PriceNetto)) {
                                                differences.push(`Cena (było: ${prevItem.PriceNetto})`);
                                            }
                                            if (prevItem && Boolean(prevItem.IsPLN) !== Boolean(inv.IsPLN)) {
                                                differences.push(`Waluta (było: ${prevItem.IsPLN ? 'PLN' : 'EUR'})`);
                                            }
                                            const isNewPos = !prevItem && prevInvoiceItems.length > 0 && Number(selectedProduct) !== 0 && !isDeleted;

                                            return (
                                                <tr key={idx + 1} style={rowStyle}>
                                                    <td className="align-middle">
                                                        <div className="d-flex align-items-center">
                                                            {differences.length > 0 && (
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-diff-${idx}`}>
                                                                            {differences.map((d, i) => (
                                                                                <div key={i}>{d}</div>
                                                                            ))}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="text-danger mr-2" style={{ cursor: "help", fontSize: "1.1rem" }}>
                                                                        <i className="fas fa-exclamation-circle"></i>
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}
                                                            {isNewPos && (
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={<Tooltip id={`tooltip-new-${idx}`}>Nowa pozycja względem poprzedniego miesiąca</Tooltip>}
                                                                >
                                                                    <span className="text-info mr-2" style={{ cursor: "help", fontSize: "1.1rem" }}>
                                                                        <i className="fas fa-info-circle"></i>
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}
                                                            <span>{!isDeleted ? visualIndex : '-'}</span>
                                                        </div>
                                                    </td>
                                                    <td className="align-middle">
                                                        <input
                                                            value={inv.Quantity}
                                                            onChange={(e) => handleItemChange(idx, 'Quantity', e.target.value)}
                                                            required={true}
                                                            disabled={isDeleted || isApproved}
                                                            className={"form-control"}
                                                            style={{ minWidth: "40px", maxWidth: "80px" }}
                                                        />
                                                    </td>
                                                    <td className="align-middle">
                                                        <input
                                                            value={inv.PriceNetto}
                                                            onChange={(e) => handleItemChange(idx, 'PriceNetto', e.target.value)}
                                                            required={true}
                                                            disabled={isDeleted || isApproved}
                                                            className={"form-control"}
                                                            style={{ minWidth: "40px", maxWidth: "80px" }}
                                                        />
                                                    </td>
                                                    <td className="align-middle d-flex justify-content-center">
                                                        <input
                                                            checked={inv.IsPLN}
                                                            style={{ width: '20px', height: '20px' }}
                                                            type={"checkbox"}
                                                            disabled={isDeleted || isApproved}
                                                            className={"form-control focus-disabled"}
                                                            onChange={(e) => {
                                                                handleItemChange(idx, 'IsPLN', Number(e.target.checked))
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="align-middle">
                                                        <select
                                                            className={"form-control focus-disabled"}
                                                            value={selectedProduct || 0}
                                                            disabled={isDeleted || isApproved}
                                                            onChange={(e) => handleItemChange(idx, 'ProductNo', e.target.value)}
                                                        >
                                                            <option className={"form-control"} value={0}>Wybierz produkt</option>
                                                            {invoiceType && invoiceType.map((type, tIdx) => (
                                                                <option className={"form-control"} key={tIdx + 1} value={type.InvoiceTypeId || tIdx + 1}>
                                                                    {type.Product}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td className="align-middle">
                                                        {invoiceType && invoiceType.map(type => {
                                                            if (Number(type.InvoiceTypeId) === Number(selectedProduct)) {
                                                                return type.ProductDesc;
                                                            }
                                                            return null;
                                                        })}
                                                    </td>
                                                    <td className="align-middle">{inv.VATRate}%</td>
                                                    <td className="align-middle">
                                                        {isDeleted ? (
                                                            <span className="text-danger small font-weight-bold">Do usunięcia</span>
                                                        ) : (
                                                            isApproved ? null : (
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    disabled={isApproved}
                                                                    onClick={() => removePosition(idx)}>
                                                                    Usuń
                                                                </button>
                                                            )
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        }) : null}
                                    </tbody>
                                </table>

                                {!isApproved && (
                                    <div className={"w-100 d-flex flex-column justify-content-center align-items-center"}>
                                        {unsavedChanges && (
                                            <div className="alert alert-warning mb-2 p-2 mt-3">
                                                <i className="fas fa-exclamation-triangle mr-2"></i>
                                                Masz niezapisane zmiany! Skreślone pozycje zostaną trwale usunięte.
                                            </div>
                                        )}

                                        <button
                                            className={`btn ${unsavedChanges ? 'btn-success' : 'btn-outline-primary'} mr-2 mt-2`}
                                            onClick={handleSaveItems}
                                        >
                                            {unsavedChanges ? 'Zapisz zmiany' : 'Zapisz'}
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </>
        ) : (<NoResults />)
    )
}

export default Invoice;